import { DownloadsFiltersProps } from './downloads-filters.types';

export const DownloadsFiltersPresets: Partial<DownloadsFiltersProps> = {};
